import { IconButton, Stack, Tooltip, useTheme } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AddIcon, CalculatorVariantIcon, DeleteIcon } from '@shared/custom-icons';
import { Link } from 'react-router';
import { AspectRatio, ReadMore } from '@mui/icons-material';
import { mgPrisRoutes } from '@retail/mgpris/config';
import { CalculusTab } from '@retail/calculus/types';
import { FILTER_CONFIG } from '@retail/products/utils';
interface Props {
  supplierIdForCalculus?: number;
  addItemToAssortment?: () => void;
  deleteItem?: () => void;
  viewItemCalculusCard?: () => void;
  viewItemProductCard?: () => void;
}

export const AssortmentTableActions = ({
  supplierIdForCalculus,
  addItemToAssortment,
  deleteItem,
  viewItemCalculusCard,
  viewItemProductCard,
}: Props) => {
  const t = useMyAssortmentTFunction();
  const theme = useTheme();
  const palette = theme.vars.palette;

  return (
    <Stack flexDirection="row" alignItems="center" gap={1.5}>
      {supplierIdForCalculus && (
        <Tooltip title={t('myAssortment.actions.goToCalculation')}>
          <IconButton
            component={Link}
            to={{
              pathname: mgPrisRoutes.calculus.calculusArea.getFullLinkPath({
                calculusArea: CalculusTab.ITEMS,
              }),
              search: `${FILTER_CONFIG.supplierNumber.urlKey}=${supplierIdForCalculus}`,
            }}
            sx={{ p: 0 }}
          >
            <CalculatorVariantIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {addItemToAssortment && (
        <Tooltip title={t('myAssortment.actions.addToOwnAssortment')}>
          <IconButton onClick={addItemToAssortment} sx={{ p: 0 }}>
            <AddIcon stroke={palette.text.secondary} />
          </IconButton>
        </Tooltip>
      )}
      {deleteItem && (
        <Tooltip title={t('myAssortment.actions.deleteItem')}>
          <IconButton onClick={deleteItem} sx={{ p: 0 }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {viewItemProductCard && (
        <Tooltip title={t('myAssortment.actions.seeProductInfo')}>
          <IconButton onClick={viewItemProductCard} sx={{ p: 0 }}>
            <AspectRatio fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      {viewItemCalculusCard && (
        <Tooltip title={t('myAssortment.actions.seeCalculusCard')}>
          <IconButton onClick={viewItemCalculusCard} sx={{ p: 0 }}>
            <ReadMore />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
};
